import menus, { webMenus } from './config.js';
import {
    default as actions,
    SET_OPERATE_STATUS,
    VISIBLE_CHANGE
} from './action';

/**
 * 默认状态
 */
const defaultState = {
    // 菜单列表
    menus,
    webMenus,
    // 菜单操作状态
    operate: {
        undo: false,
        redo: false
    },
    // 主菜单
    main: false,
    // 用户菜单
    user: false
};

/**
 * reducer
 *
 * @param {any} [state=defaultState]
 * @param {any} action
 * @returns
 */
const reducer = (state = defaultState, action) => {
    switch (action.type) {
        case VISIBLE_CHANGE:
        case SET_OPERATE_STATUS:
            return Object.assign({}, state, action.payload);
        default:
            return state;
    }
};

export default {
    reducer,
    actions
};